import Marquee from "react-fast-marquee";
import { useSite } from "@/context/SiteContext";

export default function BrandMarquee() {
  const { content } = useSite();
  const items = content?.marquee?.items || ["POTENCIA", "DISEÑO", "PERFORMANCE"];

  return (
    <section className="relative border-y border-white/10 bg-[color:var(--aurex-surface-2)] py-8 md:py-10">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((it, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-display text-5xl font-extrabold tracking-tight text-outline md:px-12 md:text-7xl">
              {it}
            </span>
            <span className="h-2.5 w-2.5 rounded-full copper-bg" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
